import React from "react";
import { Col, Image, Layout, Row, Carousel } from "antd";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

import "./Style.css";

import IMG1 from "../../assets/striving/1.jpg";
import IMG2 from "../../assets/striving/2.jpg";

// s1
import IMG3 from "../../assets/striving/3.jpg";
import IMG4 from "../../assets/striving/4.jpg";
import IMG5 from "../../assets/striving/5.jpg";
import IMG6 from "../../assets/striving/6.jpg";

// s4
import IMG7 from "../../assets/striving/7.jpg";
// s5
import IMG8 from "../../assets/striving/8.jpg";
// s6
import IMG9 from "../../assets/striving/9.jpg";
import IMG10 from "../../assets/striving/10.jpg";

// s7
import IMG11 from "../../assets/striving/11.jpg";

// slide
import SLI1 from "../../assets/striving/Slide/s1.jpg";
import SLI2 from "../../assets/striving/Slide/s2.jpg";
import SLI3 from "../../assets/striving/Slide/s3.jpg";
import SLI4 from "../../assets/striving/Slide/s4.jpg";
import SLI5 from "../../assets/striving/Slide/s5.jpg";
import SLI6 from "../../assets/striving/Slide/s6.jpg";
import SLI7 from "../../assets/striving/Slide/s7.jpg";

// ICON
import ICON1 from "../../assets/striving/icon1.svg";
import ICON11 from "../../assets/striving/icon1.1.svg";

import ICON2 from "../../assets/striving/icon2.svg";
import ICON3 from "../../assets/striving/icon3.svg";
import ICON4 from "../../assets/striving/icon4.svg";
import ICON5 from "../../assets/striving/icon5.svg";
import ICON6 from "../../assets/striving/icon6.svg";

const textContent = [
  "Intergenerational communication and language preservation have laid the foundation for connecting people, preserving cultural values, and strengthening communities. In Vietnam, we are home to 54 diverse ethnic groups, each bearing a unique cultural heritage. However, not all groups use Vietnamese as their primary language. Despite its status as the most common language, Kinh faces barriers in reaching remote regions due to geographical and cultural divides.",
  "In response, I initiated the “Language Roots” project to support ethnic minorities in learning Vietnamese. With a shared language, they can exchange knowledge, learn from previous generations, and work together to build sustainable, prosperous lives within their communities.",
  "When I began the “Language Roots” project in the summer of 2022, I could not foresee how profound this journey would become. The project brought me to Nghe An, where I organized literacy classes for 20 Thai women who had never had the opportunity to learn Vietnamese. Each day, we gathered under a large tree or in a quiet corner of a village home, and I taught them the basics of reading and writing in Vietnamese. For many, it was their first time holding a pen. I remember Ms. Lan, a woman in her fifties, whose hands trembled as she wrote her first letters, yet her determination was truly inspiring.",
  "One day, after weeks of dedicated practice, Ms. Lan wrote her name for the first time. The expression on her face was unforgettable—a mixture of pride and astonishment. Moments like these made every effort worthwhile, showing me the profound power of literacy, even as a small first step.",
  "The project reached 47 households, empowering 20 women in the community. Learning to read and write opened conversations about fundamental rights, helped them understand written materials, and reduced their vulnerability to scams and exploitation. Many women began sharing what they had learned with their families, becoming “teachers” in their own homes. By the project’s conclusion in August 2024, Language Roots had not only reduced illiteracy rates but had instilled a sense of pride and unity within the community, equipping them with the tools to protect themselves and take charge of their future.",
  "Alongside the “Language Roots” project, I continued to build “Agrifuture”, a club I founded to bring cutting-edge technology, particularly artificial intelligence, into the field of agriculture. Initially, recruiting members in a less popular field like agriculture was challenging, but with persistence, I gathered a team of 50 dedicated individuals, all eager to make a positive impact on the nation’s agriculture.",
  "One of my most memorable experiences was our trip to Van Ho, Son La, in March 2024. The team spent a day hiking through the mountains to visit pomelo farmers, listening to the challenges they faced. I met Mr. Hoang Van Ninh, a farmer with over 15 years of experience, who shared, “We grow pomelos traditionally, but the yield and quality are inconsistent. Some years, disease devastates the entire crop, and we have no way to stop it.” His words fueled my resolve to improve our AI-driven crop monitoring system to offer more tangible support to farmers.",
  "By July 2024, we returned to Van Ho to deploy the AI system and carry out several charitable activities. Seeing our technology in action was a deeply fulfilling experience. We also organized a month-long AI training program in Mai Chau for 115 citrus farmers, raised $4,000 to provide farming tools, and developed a technology curriculum for 150 students at Hang Kia Primary School. Meeting farmers like Ms. Le Thi Mai, who said, “I never thought of using technology for my crops, but now I see the benefits,” strengthened my commitment to making technology accessible to agriculture.",
  "At ATEC, I have always believed that people are the most valuable resource, especially in an evolving agricultural sector. Developing individuals and enhancing each team member’s capabilities is how we create lasting and sustainable value. When I was invited to join a project to develop a robotic support system for rehabilitation patients, I eagerly accepted to refine my technical skills and contribute meaningful benefits to the community.",
  "As Vice President and Programming Supervisor at ATEC, I am deeply committed to building a capable team that can transform technical knowledge into impactful projects. I guided 18 members in programming with C on platforms like ESP32, Arduino, and EMG sensors, exposing them to hands-on work where they could see the real-world significance of applying technology to life’s challenges. One of the most fascinating projects we undertook was developing a vision rehabilitation aid. Working alongside five experienced mentors, we persistently experimented and refined prototypes, combining HTML, CSS, JavaScript, and 3D printing technology to bring our concept closer to reality.",
  "Following that project, we shifted our focus to assistive technology, embarking on a Robotic Exoskeleton project at the Thuy An Rehabilitation Center. Using advanced sensors and specialized coding, we designed a device to help users move with ease and confidence. Witnessing patients stand or move independently with the aid of the robotic exoskeleton underscored the profound impact technology can bring. Our work is a journey of crafting solutions that empower individuals, transforming technology into a bridge that enables people to live more independently and with greater self-assurance.",
  "After attending a workshop and speaking with the founder, I sensed a shared vision and decided to join Student Do Agriculture (SDA). Although I was already familiar with repurposing agricultural byproducts, like using straw as livestock feed or fertilizer, this was the first time I saw them transformed into high-value industrial products. The idea of turning coffee grounds and sugarcane pulp into sustainable fashion materials captivated me, and I realized that this project had potential beyond anything I had imagined.",
  "I embraced the challenge of developing machine learning models to analyze the quality of these raw materials, ensuring they met industry standards. We integrated AI into the supply chain, optimizing inventory management and demand forecasting, which not only improved efficiency but also reduced waste. These efforts contributed an additional $20,000 in revenue for SDA.",
  "This project taught me that innovation often starts in unexpected places - like discarded coffee grounds or a small workshop full of creative energy.",
];

const { Content } = Layout;
const slideImages = [SLI1, SLI2, SLI3, SLI4, SLI5, SLI6, SLI7];

const StrivingPage = () => {
  const isLargeScreen = useMediaQuery({ query: "(min-width: 768px)" });

  return (
    <Layout
      style={{
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Image
          className="image-cover"
          src={IMG1}
          alt="Image 2"
          preview={false}
        />
      </div>
      <Content
        style={{
          padding: "20px",
          maxWidth: "1400px",
          width: "100%",
          margin: "0 auto",
          backgroundColor: "#fff",
        }}
      >
        {/* S1 */}
        <Row gutter={30} className="striving-seaction-1" align="middle">
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <Image
                className="w-full h-full"
                src={IMG2}
                alt="Image 2"
                preview={false}
              />
            </motion.div>
          </Col>
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                {textContent[0]}
              </p>
            </motion.div>
          </Col>
        </Row>
        {/* S2 */}

        <div className="striving-bg-1">
          {/* HEader */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            {isLargeScreen ? (
              <Image
                src={ICON1}
                alt="icon 1"
                className="striving-seaction-icon-1"
                preview={false}
              />
            ) : (
              <>
                <br />
                <Image
                  src={ICON11}
                  alt="icon 1"
                  className="striving-seaction-icon-3"
                  preview={false}
                />
              </>
            )}
          </motion.div>

          {/* content */}
          <Row gutter={30}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[1]}
                </p>
              </motion.div>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[2]}
                </p>
              </motion.div>
            </Col>
          </Row>

          <Row gutter={50}>
            <Col span={12}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Image
                  src={IMG3}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                  style={{ paddingBottom: "50px" }}
                />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Image
                  src={IMG5}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
            <Col span={12}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Image
                  src={IMG4}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                  style={{ paddingBottom: "50px" }}
                />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Image
                  src={IMG6}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
          </Row>

          <Row gutter={30} align="middle">
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[3]}
                </p>
              </motion.div>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[4]}
                </p>
              </motion.div>
            </Col>
          </Row>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            style={{
              textAlign: "right",
            }}
          >
            <Image
              src={ICON2}
              alt="icon 3"
              className="striving-seaction-icon-2"
              preview={false}
            />
          </motion.div>
        </div>

        {/* s3 */}
        <Row gutter={30} style={{ paddingBottom: "100px" }} align="middle">
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <Image
                className="w-full h-full"
                src={IMG7}
                alt="Image 2"
                preview={false}
              />
            </motion.div>
          </Col>
          <Col xs={24} md={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                {textContent[4]}
              </p>
            </motion.div>
          </Col>
        </Row>

        {/* s4 */}
        <div className="striving-bg-1">
          {/* HEader */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Image
              src={ICON3}
              alt="icon 1"
              className="striving-seaction-icon-3"
              preview={false}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            style={{ textAlign: "center" }}
          >
            <Image
              src={ICON4}
              alt="icon 4"
              className="w-full h-full"
              preview={false}
            />
          </motion.div>

          {/* content */}
          <Row gutter={30}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[6]}
                </p>
              </motion.div>
            </Col>
            {/* slide */}
            <Col span={24}>
              <Carousel autoplay arrows>
                {slideImages.map((item, index) => (
                  <Image
                    // className="image-cover"
                    src={item}
                    alt="Image slide"
                    preview={false}
                    key={index}
                  />
                ))}
              </Carousel>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[7]}
                </p>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* S6 */}
        <div className="striving-bg-1">
          {/* HEader */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Image
              src={ICON5}
              alt="icon 1"
              className="striving-seaction-icon-3"
              preview={false}
            />
          </motion.div>

          {/* content */}
          {/* s5 */}
          <Row gutter={30} align="middle">
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[8]}
                </p>
              </motion.div>
            </Col>
          </Row>

          <Row gutter={[50, 50]}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{ textAlign: "center" }}
              >
                <Image
                  src={IMG8}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
          </Row>

          <Row gutter={30}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[9]}
                </p>
              </motion.div>
            </Col>
          </Row>

          <Row gutter={[50, 50]}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{ textAlign: "center" }}
              >
                <Image
                  src={IMG9}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{ textAlign: "center" }}
              >
                <Image
                  src={IMG10}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[10]}
                </p>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* S7 */}
        <div className="striving-bg-1">
          {/* HEader */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Image
              src={ICON6}
              alt="icon 1"
              className="striving-seaction-icon-3"
              preview={false}
            />
          </motion.div>

          {/* content */}

          <Row gutter={[50, 50]}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{ textAlign: "center" }}
              >
                <Image
                  src={IMG11}
                  alt="icon 3"
                  className="striving-s1-img"
                  preview={false}
                />
              </motion.div>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[11]}
                </p>
              </motion.div>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[12]}
                </p>
              </motion.div>
            </Col>
            <Col span={24}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <p
                  className="text-color-2"
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "16px",
                    lineHeight: "1.8",
                    textAlign: "justify",
                  }}
                >
                  {textContent[13]}
                </p>
              </motion.div>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default StrivingPage;

// 22 14.674  350
